import { render, staticRenderFns } from "./CitiesTowns.vue?vue&type=template&id=afb3f08e"
import script from "./CitiesTowns.vue?vue&type=script&lang=js"
export * from "./CitiesTowns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../mbp_crm-adminclient-golive1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports